import {
  Component,
  EventEmitter,
  HostBinding,
  OnDestroy,
  OnInit,
  Output,
  Input,
} from "@angular/core";
import { Subject, Subscription } from "rxjs";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";
import { CommonSVG } from "../../enums/assets.enum";
//UPGRADE-17  import { ScoreCardService } from "src/app/score-card/services/score-card.service";

@Component({
  selector: "xcdrs-search-field",
  templateUrl: "./search-field.component.html",
  styleUrls: ["./search-field.component.scss"],
})
export class SearchFieldComponent implements OnInit, OnDestroy {

  hasValue = false;
  searchText: string = '';

  messages: any[] = [];
  subscription: Subscription;
  CommonSVG = CommonSVG;

  @Input() isV2: boolean = false;

  @Input() bgColor: string = '';
  
  @Input() inputInlineStyle: string = '';

  @Input() searchTextsearchText: string = ''
  
  @Input('input') set searchInput(value: string) {
    this.searchText = value;
    //this._searchInput = value;
    //this.keyword.setValue(this._searchInput, { emitEvent: false }xcdrs-search-field)
  }

  @Input() isFullWidth: boolean = false;

  @Output() search = new EventEmitter<string>();

  private inputChangeTimer: any;
  private inputChangeSubject = new Subject<string>();

  //UPGRADE-17 
  // constructor(private _scoreCardService: ScoreCardService,) {
  //   this.subscription = this._scoreCardService.onMessage().subscribe(message => {
  //     if (message) {
  //       this.searchText = '';
  //     } else {
  //     }
  // });
  // }

  @HostBinding("class.empty")
  private get isEmpty() {
    return !this.hasValue;
  }

  ngOnInit(): void {
    this.inputChangeSubject
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe((searchTerm) => {
        this.search.emit(searchTerm.toLowerCase());
      });
  }

  onInputChange(searchTerm: string) {
    this.hasValue = !!searchTerm;
    // this.inputChangeSubject.next(searchTerm);
    // Clear previous timer if it exists
    if (this.inputChangeTimer) {
      clearTimeout(this.inputChangeTimer);
    }

    this.inputChangeTimer = setTimeout(() => {
      this.inputChangeSubject.next(searchTerm);
    }, 700);
  }

  onInputEmpty(searchTerm: string) {
    if (searchTerm?.length == 0) {
      this.hasValue = !!searchTerm;
      this.inputChangeSubject.next(searchTerm);
    }
  }

  ngOnDestroy(): void {
    this.inputChangeSubject.unsubscribe();
  }

  clearSearch() {
    this.searchText = '';
    this.inputChangeSubject.next(this.searchText);
  }
}
